<template>
    <b-container fluid class="mt-4">
        <p><router-link to="/user-manual">Back to User Manual Homepage</router-link></p>
        <h2>FarmD User Manual: {{pageDisplayName}}</h2>
        <component :is="pageContent" />
    </b-container>
</template>

<script>
    import Gameplay from './Gameplay';
    import Menus from './Menus';
    import Miscellaneous from './Miscellaneous';
    import ModdingQuickstart from './ModdingQuickstart';
    
    export default {
        name: 'ManualPages',
        computed: {
            pageContent() {
                var guides = {
                    "Gameplay": Gameplay,
                    "Menus": Menus,
                    "Miscellaneous": Miscellaneous,
                    "ModdingQuickstart": ModdingQuickstart,
                }

                return guides[this.$route.params.pageName];
            },
            pageDisplayName() {
                return this.$route.params.pageName.replace(/([A-Z])/g, ' $1').trim();
            }
        }
    }
</script>

<style>
    .guide-list {
        margin-right: auto;
        font-size: 1em;
    }

    .guide-list .btn {
        font-size: 1em;
        padding: 0px;
        padding-bottom: 0.15em;
    }

    .guide-list img {
        max-height: 500px;
        margin-bottom: 1em;
    }

    .guide-list h4 {
        border: 2px solid gray;
        border-radius: 5px;
        padding: 1rem;
        margin-top: 5rem;
        margin-bottom: 2rem;
    }

    body {
        margin-bottom: 100px
    }

    .table-of-contents .active {
        font-weight: bold;
    }
</style>
